const ACTION_REQUEST_MARKER = ":saved-action:"
const COMBINED_ACTION_REQUEST_MARKER = ":saved-actions:"
const MAX_COMBINED_ACTIONS = 8
const MAX_ACTION_ID_LENGTH = 120

export function savedActionClientRequestId(taskId: string, actionId: string, requestId: string): string {
    return `${taskId}${ACTION_REQUEST_MARKER}${encodeURIComponent(actionId)}:${requestId}`
}

export function combinedSavedActionClientRequestId(taskId: string, actionIds: readonly string[], requestId: string): string {
    return `${taskId}${COMBINED_ACTION_REQUEST_MARKER}${encodeURIComponent(JSON.stringify(actionIds))}:${requestId}`
}

export function savedActionIdsFromClientRequestId(clientRequestId: string | undefined): string[] {
    if (!clientRequestId) return []
    const combinedMarkerIndex = clientRequestId.indexOf(COMBINED_ACTION_REQUEST_MARKER)
    if (combinedMarkerIndex !== -1) {
        const encodedActionIds = clientRequestId.slice(combinedMarkerIndex + COMBINED_ACTION_REQUEST_MARKER.length).split(":", 1)[0]
        if (!encodedActionIds) return []
        try {
            const actionIds: unknown = JSON.parse(decodeURIComponent(encodedActionIds))
            return Array.isArray(actionIds) &&
                actionIds.length > 0 &&
                actionIds.length <= MAX_COMBINED_ACTIONS &&
                actionIds.every((actionId) => typeof actionId === "string" && actionId.length > 0 && actionId.length <= MAX_ACTION_ID_LENGTH)
                ? actionIds
                : []
        } catch {
            return []
        }
    }

    const markerIndex = clientRequestId.indexOf(ACTION_REQUEST_MARKER)
    if (markerIndex === -1) return []
    const encodedActionId = clientRequestId.slice(markerIndex + ACTION_REQUEST_MARKER.length).split(":", 1)[0]
    if (!encodedActionId) return []
    try {
        return [decodeURIComponent(encodedActionId)]
    } catch {
        return []
    }
}
